import React from "react";
import moment from "moment";
import { Table } from "react-bootstrap";

import { toast } from "react-toastify";
import { DatePicker, Skeleton } from "antd";
import dayjs from "dayjs";
import { manualPcr } from "../../../actions/pcr";
import "./ManualPcrTableQueue.css";

class ManualPcrTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      manualPcrTableData: [],
      manualPcrDate: new Date(),
      loading: false,
      apiController: null,
    };
    this.isUnmounted = false;
  }

  componentDidMount() {
    const url = window.location.href;
    if (url.includes("pcr")) {
      let today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
      const yyyy = today.getFullYear();

      today = `${mm}/${dd}/${yyyy}`;
      this.setState({ manualPcrDate: today });
      this.generateManualPcr(today);
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true; // Set the flag to indicate unmounting
    this.abortPrevApiCall(null);
  }

  onSelectDateManualPcr = (param) => {
    if (!param || param.length === 0) { return; }
    const selectedDate = param.$d;
    const targetDateStr = moment(selectedDate.getTime()).format("MM/DD/YYYY");

    if (selectedDate) {
      this.setState(() => ({
        manualPcrDate: selectedDate,
        // prevDate: prevState.manualPcrDate,
      }), () => {
        this.generateManualPcr(targetDateStr);
      });
    }
  }

  /**
   * Use the AbortController to cancel the last producttemplates/ call if the last call was still in progress.
   * @param {*} controller
   */
  abortPrevApiCall = (controller) => {
    const { apiController } = this.state;
    if (apiController) {
      apiController.abort();
    }
    this.setState({ apiController: controller });
  };

  generateManualPcr = async (target_date) => {
    this.setState({ loading: true }, async () => {
      const controller = new AbortController();
      this.abortPrevApiCall(controller);
      const results = await manualPcr(target_date, controller.signal);

      if (results && results.success) {
        this.setState({ manualPcrTableData: results.list, loading: false });
      } else if (!results.canceled) {
        this.setState({ loading: false });
        toast.error("Something went wrong");
      }
    });
  }

  addTableRow = (data, i) => (
    <tr key={i}>
      <td className="ManualPcrQueue__Td">{data.Test}</td>
      <td className="ManualPcrQueue__Td">
        {data.GenistaID.map((p, idx) => (
          <span key={idx}>
            { `${p}${data.GenistaID.length - 1 === idx ? "" : ","}`}
            {" "}
          </span>
        ))}
      </td>
    </tr>
  )

  addTableSkeleton = (i) => (
    <tr key={`ManualPcrQueue-tr-${i}`}>
      {[...Array(2)].map((_, j) => (
        <td key={`ManualPcrQueue-${i}-${j}`} className="ManualPcrQueue__Skeleton__SampleTd">
          <Skeleton.Input className="ManualPcrQueue__Skeleton__Sample" active />
        </td>
      ))}
    </tr>
  );

  render() {
    const {
      manualPcrDate,
      manualPcrTableData,
      loading,
    } = this.state;

    return (
      <div>
        {/* <div style={{display:'inline-block', margin:"10px"}}>
          <div className="input-group"></div>
        </div> */}
        <div className="ManualPcrQueue__DatePicker">
          <DatePicker
            showToday
            allowClear={false}
            format="MM/DD/YYYY"
            defaultValue={(manualPcrDate === "" || manualPcrDate === "Invalid date") ? "" : dayjs(manualPcrDate)}
            className="ManualPcrTableQueueDate"
            disabledDate={(current) => current.isAfter(dayjs())}
            onChange={(date) => this.onSelectDateManualPcr(date)}
          />
        </div>

        <Table striped={!loading} bordered={!loading} hover={!loading} className="table">
          <thead>
            <tr className="ManualPcrQueue__Heading">
              <td>Test</td>
              <td>GenistaID</td>
            </tr>
          </thead>

          <tbody>
            {!loading
              && manualPcrTableData.map((data, index) => this.addTableRow(data, index + 1))}
            {loading
              && [...Array(6)].map((_, index) => this.addTableSkeleton(index + 1))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ManualPcrTable;
